import styled from 'styled-components';

const Splitter = styled.span`
    flex: 1
`;

export { Splitter };
